import React from 'react';
import { Title } from '../components';
import Review from './Review';
import { reviews } from '../data';

const Testimonials = () => {
  return (
    <section className="section bg-blue-50" id="reviews">
    {/* <section className="section bg-purple-100"> */}
      <Title title="reviews" />
      <p className="text-center text-lg sm:wtext-2xl font-semibold mb-8">
        Read trusted reviews from our customers
      </p>
      <div className="section-center bg-blue-100 rounded-full sm:rounded-full">
        <div className="max-w-5xl px-4 py-8 mx-auto">
          {/* TESTIMONIAL 1 */}
          {/* <div className="p-8 bg-gray-100 rounded-lg">
            <div className="grid grid-cols-1 gap-12 sm:grid-cols-3 sm:items-center">
              <div className="relative">
                <div className="aspect-w-1 aspect-h-1">
                  <img
                    src="https://www.hyperui.dev/photos/man-5.jpeg"
                    alt=""
                    className="object-cover rounded-lg"
                  />
                </div>

                <div className="absolute inline-flex px-4 py-2 bg-white rounded-lg shadow-xl -bottom-4 -right-4">
                  <span className="inline-block w-12 h-10 bg-gray-100 rounded-lg"></span>
                </div>
              </div>

              <blockquote className="sm:col-span-2 ">
                <p className="text-xl font-medium sm:text-2xl">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt
                  perspiciatis cumque neque ut nobis excepturi, quasi iure
                  quisquam autem alias.
                </p>

                <cite className="inline-flex items-center mt-8 not-italic">
                  <span className="hidden w-6 h-px bg-gray-400 sm:inline-block"></span>
                  <p className="text-sm text-gray-500 uppercase sm:ml-3">
                    <strong>Simon Cooper</strong>, Inbetweener Co.
                  </p>
                </cite>
              </blockquote>
            </div>
          </div> */}

          {/* TESTIMONIAL 2 */}
          <section className="my-20 text-gray-700">
            {/* <div className="text-center md:max-w-xl lg:max-w-3xl mx-auto">
              <h3 className="text-3xl font-bold mb-6 text-gray-800">
                Testimonials
              </h3>
              <p className="mb-6 pb-2 md:mb-12 md:pb-0">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit,
                error amet numquam iure provident voluptate esse quasi,
                veritatis totam voluptas nostrum quisquam eum porro a pariatur
                veniam.
              </p>
            </div> */}

            <div className="grid md:grid-cols-3 gap-6 lg:gap-12 text-center">
              {reviews.map(review => (
                <Review key={review.id} review={review} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
